import React, { useEffect, useState } from "react";
import SurveyHomeCardPreview from "./SurveyHomeCardPreview";
import SurveyQuestionPreview from "./SurveyQuestionPreview";

const previewWidth = 460;
const previewHeight = 995;
const minZoom = 40;
const maxZoom = 130;
const zoomStep = 10;

const HomeCardPreview = ({ form }) => (
  <div className="survey-mobile-screen survey-mobile-home-screen">
    <div className="survey-mobile-status-bar">
      <span>11:10</span>
      <span>● ◢ ▮</span>
    </div>
    <div className="survey-mobile-home-placeholder" />
    <SurveyHomeCardPreview form={form} />
    <div className="survey-mobile-home-placeholder lower" />
  </div>
);

const SurveyMobilePreview = ({
  form,
  selectedQuestionId,
  questionOnly = false,
  homeZoom = 100,
}) => {
  const [previewSelections, setPreviewSelections] = useState({});
  const questions = form.questions || [];
  const [zoom, setZoom] = useState(
    selectedQuestionId === "home" ? homeZoom : 50,
  );
  const index = questions.findIndex(
    (question) => question.id === selectedQuestionId,
  );
  const question = index >= 0 ? questions[index] : null;
  const options =
    question &&
    (question.type === "single_choice" || question.type === "multi_choice")
      ? question.options || []
      : [];
  const defaultSelection = options.length
    ? [options[0].id]
    : question && question.type === "single_choice" && question.allowOther
      ? ["other"]
      : [];
  const selectedIds =
    question && previewSelections[question.id]
      ? previewSelections[question.id]
      : defaultSelection;
  const selectOption = (optionId) => {
    if (!question) return;
    const nextIds =
      question.type === "multi_choice"
        ? selectedIds.includes(optionId)
          ? selectedIds.filter((id) => id !== optionId)
          : [...selectedIds, optionId]
        : [optionId];
    setPreviewSelections({ ...previewSelections, [question.id]: nextIds });
  };

  useEffect(() => {
    if (selectedQuestionId === "home") {
      setZoom(homeZoom);
    } else {
      setZoom(50);
    }
  }, [homeZoom, selectedQuestionId]);

  const zoomScale = zoom / 100;
  const scaledWidth = previewWidth * zoomScale;
  const scaledHeight = previewHeight * zoomScale;

  return (
    <section className="survey-builder-preview-panel">
      <div className="survey-builder-panel-heading">
        <div>
          <strong>Mobile preview</strong>
          <span>
            {question
              ? `Question ${index + 1} of ${questions.length}`
              : questionOnly ? "Select a question" : "Home card"}
          </span>
        </div>
        <div className="survey-builder-preview-heading-actions">
          <div
            className="survey-builder-zoom-controls"
            aria-label="Preview zoom controls"
          >
            <button
              type="button"
              aria-label="Zoom out"
              title="Zoom out"
              disabled={zoom <= minZoom}
              onClick={() => setZoom(Math.max(minZoom, zoom - zoomStep))}
            >
              −
            </button>
            <button
              type="button"
              className="survey-builder-zoom-value"
              title="Reset zoom"
              onClick={() => setZoom(100)}
            >
              {zoom}%
            </button>
            <button
              type="button"
              aria-label="Zoom in"
              title="Zoom in"
              disabled={zoom >= maxZoom}
              onClick={() => setZoom(Math.min(maxZoom, zoom + zoomStep))}
            >
              +
            </button>
          </div>
          <span className="survey-builder-live-badge">
            <i /> Live preview
          </span>
        </div>
      </div>
      <div
        className="survey-builder-preview-stage"
        style={{ minHeight: `${Math.max(680, scaledHeight + 48)}px` }}
      >
        <div
          className="survey-mobile-preview-scaler"
          style={{ width: `${scaledWidth}px`, height: `${scaledHeight}px` }}
        >
          <div
            className="survey-mobile-preview-transform"
            style={{ transform: `scale(${zoomScale})` }}
          >
            {question ? (
              <SurveyQuestionPreview
                question={question}
                index={index}
                total={questions.length}
                selectedIds={selectedIds}
                onSelect={selectOption}
              />
            ) : !questionOnly ? (
              <HomeCardPreview form={form} />
            ) : (
              <div className="survey-mobile-screen survey-mobile-question-empty-preview">
                <i className="fa fa-list-alt" />
                <strong>Select or add a question</strong>
                <span>The customer question preview will appear here.</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SurveyMobilePreview;
